<template>
  <div class="container overflow-hidden">
    <b-link
      class="font-weight-bold d-block text-nowrap mr-3 mb-2"
      @click="mudarComponente()"
    >
      <el-button
        id="voltar-lista-curso"
        style="border: none; background-color: transparent;"
        type="button"
        class="is-plain"
      >
        <i class="el-icon-back" />
        Cursos
      </el-button>
    </b-link>
    <div class="row gx-5n mt-2">
      <div class="card col-12">

        <b-tabs
          pills
          align="start"
          class="mt-2"
        >
          <b-tab
            id="tab-geral-curso"
            class="mt-2"
            title="Geral"
            @click="$store.commit('appHelperTour/SET_TYPE_HELPER_TOUR', 'GeralCurso')"
          >
            <b-card-text>
              <GeralCurso />
            </b-card-text>
          </b-tab>
          <b-tab
            id="tab-alunos-curso"
            title="Alunos"
            @click="$store.commit('appHelperTour/SET_TYPE_HELPER_TOUR', 'AlunosCurso')"
          >
            <b-card-text>
              <Alunos />
            </b-card-text>
          </b-tab>
          <b-tab
            id="tab-modulos-curso"
            title="Modulos"
            :active="tabactive"
            @click="$store.commit('appHelperTour/SET_TYPE_HELPER_TOUR', 'ModuloCurso')"
          >
            <b-card-text>
              <ModuloCurso />
            </b-card-text>
          </b-tab>
        </b-tabs>

      </div>
    </div>
  </div>
</template>

<script>
import {
  BTabs, BTab, BFormGroup, BFormCheckboxGroup, BFormCheckbox, VBTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import GeralCurso from '@/views/App/Cursos/GeralCurso.vue'
import ModuloCurso from '@/views/App/Cursos/ModulosCurso.vue'
import Alunos from '@/views/App/Cursos/Alunos.vue'
import { useApiAWS, useApi } from '@/composables/useApi'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'

const apiAws = useApiAWS()
const apiBack = useApi()

export default {

  components: {
    Alunos,
    ModuloCurso,
    GeralCurso,
    BTabs,
    BTab,
    BFormGroup,
    BFormCheckboxGroup,
    BFormCheckbox,
    VBTooltip,
    vSelect,

  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      tabactive: false,
      activeTab: 'Geral',
      dir: 'ltr',
      option: [],
      nextTodoId: 2,
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND,
    }
  },

  computed: {
    getUserData() {
      return JSON.parse(localStorage.getItem('userData'))
    },
  },
  mounted() {
    const tabParam = this.$route.query.tab
    if (tabParam === 'Modulos') {
      this.tabactive = true
    } console.log(tabParam)
    this.$store.commit('appHelperTour/SET_TYPE_HELPER_TOUR', 'curso')
  },

  methods: {
    mudarComponente() {
      return this.$router.push('/cliTreinamentos')
    },
    fluxo() {
      this.$router.push({ name: 'fluxoMensagem' })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-select.scss';
.card {
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  padding: 20px;
}

.avatar-container {
  position: relative;
}

.file-input-label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #fff;
  cursor: pointer;
}

.file-input-label svg {
  width: 76px;
  height: 76px;
  position: absolute;
  top: 31px;
  stroke-width: 0.8;
}

.file-input {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 2;
}

.avatar {
  width: 90px;
  height: 90px;
  object-fit: cover;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.avatar:hover {
  border: 2px solid red;
}

.avatar-selecionado {
  border: 2px solid red;
}

.Scroll {
  height: 100px;
  overflow-y: scroll;

}

.el-icon-document-copy {
  padding: 1px;
  font-size: 25px;
  color: #2e2e2f;
  transition: color .15s linear;
}

#texto {
  color: black;
  height: 214px;
  font-size: large;
  font-family: Verdana;
}

.ant-input {
  box-sizing: border-box;
  margin: 0;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: "tnum", "tnum";
  position: relative;
  display: inline-block;
  width: 100%;
  min-width: 0;
  padding: 7px 11px;
  color: rgb(24 8 8 / 85%);
  font-size: 14px;
  line-height: 1.5715;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  transition: all .3s;
}
.fixed-button {
  position: fixed;
  bottom: 20px; /* Ajuste o valor conforme necessário para posicionar o botão verticalmente */
  right: 20px; /* Ajuste o valor conforme necessário para posicionar o botão horizontalmente */
  z-index: 999; /* Certifique-se de que o botão esteja acima de outros elementos na página, se necessário */
}
</style>
